// @flow
import type {AxiosPromise} from 'axios';

import type {ActionType} from 'constants/flow/flowTypes';
import {PRODUCT} from 'constants/actions';

import type {ProductBannerType} from './bannerType';

export const initialState = {
    status: '',
    content: '',
    coupon: '',
    contentType: '',
};

/**
 * Product banner reducer
 *
 * @param {ProductBannerType} state - reducer state
 * @param {ActionType} action - dispatched action
 * @return {ProductBannerType} new reducer state
 */
export function productBanner(
    state: ProductBannerType = initialState,
    action: ActionType<AxiosPromise>,
): ProductBannerType {
    switch (action.type) {
        case `${PRODUCT.FETCH_BANNER}_PENDING`: {
            return {...state, status: 'pending'};
        }

        case `${PRODUCT.FETCH_BANNER}_REJECTED`: {
            return {...state, status: 'rejected'};
        }

        case `${PRODUCT.FETCH_BANNER}_FULFILLED`: {
            return {
                ...state,
                status: 'fulfilled',
                content: action.payload.data[0].banner,
                coupon: action.payload.data[0].coupon || '',
                contentType: action.payload.data[0].content_type || '',
            };
        }

        default:
            return state;
    }
}
